import {
  ADD_OPEN_MODAL,
  VIEW_EVENT_MODAL,
  VIEW_TASK_MODAL,
} from "../../../constants";
import { useModalState } from "../../../state/modalState";

const useEventInfoButtonData = (setSelectedEvent, allDay, eventColor) => {
  const [, dispatch] = useModalState();

  // toggle info modal
  const toggleInfoModal = (item, coords) => {
    dispatch({
      type: ADD_OPEN_MODAL,
      modalType: item?.resource === "Task" ? VIEW_TASK_MODAL : VIEW_EVENT_MODAL,
      ref: { id: item.id },
      modalData: {
        item,
        width: coords.width,
        height: coords.height,
        clearSelectedEvent: () => {
          setSelectedEvent("");
        },
      },
      position: {
        x: coords.x,
        y: coords.y,
      },
    });
  };

  const eventButtonStyles = {
    display: "flex",
    alignItems: "center",
    width: "100%",
  };

  const indicatorStyles = {
    marginRight: "10px",
    transform: "translateY(-1px)",
  };

  const eventButtonTextStyles = {
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    textAlign: "left",
    overflow: "hidden",
    width: "calc(100% - 20px)",
    color: `${allDay && "white"}`,
    backgroundColor: `${allDay && eventColor}`,
  };

  return {
    toggleInfoModal,
    eventButtonStyles,
    eventButtonTextStyles,
    indicatorStyles,
  };
};

export default useEventInfoButtonData;
